export default __webpack_public_path__ + "static/media/goshen52.29753fd7.JPG";